import React from 'react';
import { getText } from "./language_helpers";
import { getInstanceConfig } from "./instance_helpers";

const sixBySixLikelihoodOptions = () => {
  const { risk_matrices={} } = getInstanceConfig();
  const configs = risk_matrices['6x6'] || [];
  
  let likelihooOptions = configs.map((config) => {
    const { likelihood_level, likelihood_rating, quantitative_description } = config;
    const likelihood_level_desc = `${likelihood_rating}: ${getText(likelihood_level)}`;

    const text = (
      <span>
        <div>{likelihood_level_desc}</div>
        <div className="quantitative-description">({getText(quantitative_description)})</div>
      </span>
    );
      
    return {
      key: likelihood_rating,
      value: likelihood_rating,
      type: likelihood_level,
      text
    }
  });

  likelihooOptions.push({
    key: '(N/A) Not Applicable',
    value: 'NA',
    type: '',
    text: getText('(N/A) Not Applicable')
  })
  return likelihooOptions
}

const fiveByFiveLikelihoodOptions = () => {
  return [
    {
      key: '1',
      value: '1',
      type: 'Unlikely in 100 years',
      text: getText('1: Unlikely in 100 years')
    },
    {
      key: '2',
      value: '2',
      type: 'Once in 10 to 100 years',
      text: getText('2: Once in 10 to 100 years')
    },
    {
      key: '3',
      value: '3',
      type: 'Once in 1 to 10 years',
      text: getText('3: Once in 1 to 10 years')
    },
    {
      key: '4',
      value: '4',
      type: 'Once a year',
      text: getText('4: Once a year')
    },
    {
      key: '5',
      value: '5',
      type: 'Several times a year',
      text: getText('5: Several times a year')
    },
    {
      key: '(N/A) Not Applicable',
      value: 'NA',
      type: '',
      text: getText('(N/A) Not Applicable')
    }
  ];
}

const getLikelihoodOptions = () => {
  const { risk_matrix="5x5" } = getInstanceConfig();
  if (risk_matrix === "6x6") {
    return sixBySixLikelihoodOptions();
  } else {
    return fiveByFiveLikelihoodOptions();
  }
}

export {
  getLikelihoodOptions,
  fiveByFiveLikelihoodOptions,
  sixBySixLikelihoodOptions
}


// WEBPACK FOOTER //
// ./src/helpers/risk_matrix_helpers.js